import script from "./safeguardProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./safeguardProduct.vue?vue&type=script&setup=true&lang=js"

import "./safeguardProduct.vue?vue&type=style&index=0&id=0152256f&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0152256f"]])

export default __exports__